import { render, staticRenderFns } from "./Fitness.vue?vue&type=template&id=e21f2068"
import script from "./Fitness.vue?vue&type=script&lang=js"
export * from "./Fitness.vue?vue&type=script&lang=js"
import style0 from "./Fitness.vue?vue&type=style&index=0&id=e21f2068&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports